module.exports = __webpack_public_path__ + "static/media/43import-77.473a8db8.xlsx";